import * as React from "react";
import renderUtils from "../../../helpers/renderUtils";
import {Badge} from "react-bootstrap";

const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "machineType",
            label: t ? t("common.machine_type") : "Typ maszyny",
            column: 1,
            type: "enum",
            enumType: "enums/machineType",
            mandatory: true
        },
        {
            name: "machine",
            label: t ? t("common.machine") : "Maszyna",
            column: 1,
            type: "dictionary",
            withAutocomplete: true,
            dictionary: "machine",
            mandatory: true,
            renderOption: (option) => <>{renderUtils.renderMachine(option)} <Badge
                variant={"primary"}>{option.packingLineName}</Badge></>,
            filterBy: (option, props) =>
                String(option.presentableName).toLowerCase().indexOf(props.text.toLowerCase()) !== -1
            ,
            placeholder: t ? t("forms.line_machine_search_placeholder") : "Wpisz nazwę linii lub model maszyny",
            conditionalOn: "machineType",
            conditionalOnNotNull: true,
            filterValues: function (dictionaries, formData, values) {
                if (formData && formData["machineType"]) {
                    return values.filter(machine => machine.machineType === formData["machineType"] )
                }
            }
        }

    ]


});

export default fields;